export default __webpack_public_path__ + "img/comprehensiveListings.d279ced0.svg";